import React from "react";
import { WriteReviewSSR } from "tsi-common-react/src/apps/reviews/WriteReviewSSR/index";

import { templates } from "@reactivated";

export const Template = (
    props: templates.WriteReviewTemplate,
): React.JSX.Element => {
    return <WriteReviewSSR {...props} brand="Stearns and Foster" />;
};
